"use client"

import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import getClassNameFactory from "../../../lib/get-class-name-factory"
import { generateResponsiveCSS } from "../../../lib/helper"
import styles from "./css/styles.module.css"

const getClassName = getClassNameFactory("SimpleGrid", styles)

export interface SimpleGridProps extends CommonStylesProps {
  slides: {
    id?: number
    image?: string
    urlAppStore?: string
    urlGGStore?: string
    titleSlideItem?: string
    description?: string
  }[]
  imageHeight?: number
  imageWidth?: number
  imageBorderRadius?: number
  spaceBetween?: number
  slidesPerView?: number
  loop?: boolean
  speed?: number
  timeDelay?: number
  isPagination?: boolean
  isNavigation?: boolean
  autoPlay?: boolean
  pagination?: "default" | "custom"
  breakpoint?: []
}

export const RenderConfig: ComponentConfig<SimpleGridProps> = {
  render: ({ slides, styles, responsiveType, className, ...restProps }) => {
    const id = `simple-slider-${Math.random().toString(36).substr(2, 9)}`

    const mergedStyles = {
      mobile: { ...styles?.mobile },
      tablet: { ...styles?.tablet },
      desktop: { ...styles?.desktop },
    }

    const responsiveCSS = generateResponsiveCSS(id, mergedStyles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <div className={`gridContainer ${twMerge(className)} grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4`}>
          {slides.map(({ id, image, urlAppStore, urlGGStore, description, titleSlideItem }, index) => (
            <div data-aos="fade-right" data-aos-duration="1500" className="flex justify-center">
              <div
                key={index}
                className={`gridItem transition-transform py-[40px] flex flex-col duration-300 w-[231px] max-sm:w-[250px] ease-in-out transform rounded-[15px] overflow-hidden mt-[30px] max-sm:mt-[10px]`}
                style={{ backgroundColor: "rgb(245, 245, 245)" }}
              >
                <div className="bg-[#1B1C1E] opacity-10 text-white text-[18px] mb-[10px] rounded-[15px] flex justify-center items-center w-[104px] h-[40px] self-center">
                  <p>JOB</p>
                </div>
                <div className="text-center">
                  <h3 className="transition-transform h-[50px] duration-300 ease-in-out transform group-hover:text-[#3BC873] font-bold md:text-[20px] leading-[19px] my-[10px] px-2">
                    {titleSlideItem}
                  </h3>
                  <p className=" text-[15px] font-normal leading-[19px] pb-[15px] px-[10px]">Ho Chi Minh</p>
                </div>
                <div className="flex flex-row justify-center items-center self-center  bg-[#3BC873] text-white w-[140px] h-[40px] rounded-[40px] text-[15px]">
                  <p>View Job Detail</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    )
  },
}
